var scope_0 = require('/vercel/path0/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/051c735b8020954f24c03a7266bf5ed0.js').default;
var scope_1 = require('/vercel/path0/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/0c87b2aaba61e15c5ff08f31970e7adf.js').default;
var scope_2 = require('/vercel/path0/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/28b75d2a930fc83414ccd521c746aa4f.js').default;
var scope_3 = require('/vercel/path0/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/7e315f79c224c7ded6ed23349d93362a.js').default;
var scope_4 = require('/vercel/path0/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/9b6215eef21f50f0e64687df0994f781.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4 )
    